"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuSeparatorTheme = exports.MenuSeparator = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../../constants/spacing");
var _useTheme = require("../../../theme/utils/useTheme");
// eslint-disable-next-line @typescript-eslint/no-empty-interface

const menuSeparatorTheme = (0, _sdsThemeInternal.themed)({
  color: {
    "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--default"),
    "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weaker")
  },
  height: {
    "lodestar-light": "2px",
    "ursa-light": "1px"
  },
  gap: {
    // 11 * 2 + 2 = 24px total
    "lodestar-light": "11px",
    // 12 * 2 + 1 = 25px total and that's fine per UX.
    "ursa-light": "12px"
  },
  borderRadius: {
    "lodestar-light": "0px",
    "ursa-light": "3px"
  }
});
exports.menuSeparatorTheme = menuSeparatorTheme;
const StyledMenuSeparator = (0, _styled.default)("hr")`
    display: block;
    min-height: ${_ref => {
  let {
    themeMode
  } = _ref;
  return menuSeparatorTheme.height(themeMode);
}};
    background-color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return menuSeparatorTheme.color(themeMode);
}};
    margin: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return menuSeparatorTheme.gap(themeMode);
}} ${_spacing.sizes.medium}px;
    padding: 0;
    border: none;
    border-radius: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return menuSeparatorTheme.borderRadius(themeMode);
}};
`;

/**
 * https://www.w3.org/TR/wai-aria-1.2/#separator
 */
const MenuSeparator = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(StyledMenuSeparator, (0, _extends2.default)({}, props, {
    ref: ref,
    role: "separator",
    themeMode: themeMode,
    "data-client-id": props.clientId
  }));
});
exports.MenuSeparator = MenuSeparator;
MenuSeparator.displayName = "MenuSeparator";
//# sourceMappingURL=MenuSeparator.js.map